<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <div class="admin-add-products fullheight">
        <v-toolbar dark :color="'#9e9e9e'">
          <v-btn icon dark @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            <h1
              class="header-tittle"
              :style="{ color: colorsGeneralSecondary }"
            >
              Cola de Impresión
            </h1>
          </v-toolbar-title>
        </v-toolbar>

        <v-container fluid>
          <v-row justify="center" class="mt-4">
            <v-col cols="12" md="2" sm="3">
              <v-select
                v-model="selectedQR"
                :items="listQr"
                style="width: 130px"
                :label="selectLabelQR"
                class="mx-3"
                @change="onChangeTable"
                :item-text="qr => tableQRLabel(qr.table)"
                item-value="table"
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" justify="center" md="2" sm="1">
              <button
                class="admin-reset-filters pa-2"
                @click="resetFilters"
                :style="adminResetFiltersTheme"
              >
                Borrar Filtros
              </button>
            </v-col>
          </v-row>
        </v-container>
        <div class="admin-categories pt-4">
          <div class="tabs-stage">
            <div id="tab-1" class="table-scroll">
              <table class="header-table">
                <tr class="header-row" :style="{ color: tableValuesTheme }">
                  <th
                    class="header-name"
                    :style="{ color: tableHeaderTextTheme }"
                  >
                    Peticion
                  </th>
                  <th
                    class="header-notes"
                    :style="{ color: tableHeaderTextTheme }"
                  >
                    Hora
                  </th>
                  <th
                    class="header-notes1"
                    :style="{ color: tableHeaderTextTheme }"
                  >
                    Impresora
                  </th>
                  <th
                    class="header-notes2"
                    :style="{ color: tableHeaderTextTheme }"
                  >
                    Status
                  </th>
                  <th
                    class="header-action"
                    :style="{ color: tableHeaderTextTheme }"
                  ></th>
                </tr>
              </table>

              <table class="gfg">
                <tr
                  v-for="(printerError, index) in filteredErrors"
                  :key="`error_${index}`"
                  :style="{ color: tableValuesTheme }"
                >
                  <td class="geeks-notes" style="padding-right: 20px">
                    Mesa {{ printerError.data.id }}
                  </td>
                  <td class="geeks-notes1" style="padding-right: 20px">
                    {{ printerError.data.time }}
                  </td>
                  <td class="geeks-notes2">
                    {{ printerError.printerName }}
                  </td>
                  <td class="geeks-notes3">
                    <span v-if="printerError.status === true" class="red-dot">
                    </span>
                    <span v-else class="green-dot"> </span>
                  </td>
                  <td class="geeks-notes3">
                    <span>
                      <v-checkbox
                        hide-details
                        class="mt-0"
                        :value="printerError"
                        v-model="selectedErrors"
                        @change="addSelectedItem(printerError)"
                      ></v-checkbox>
                    </span>
                  </td>
                </tr>
                <tr v-if="printerErrors.length === 0">
                  <div class="no-record-message">
                    No se han encontrado resultados. Por favor, revisa los
                    filtros de búsqueda!
                  </div>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <v-row class="justify-center btn-container">
          <v-col class="col-12 col-sm-3 text-center text-sm-right">
            <button class="reprint-action-btn" @click="deleteSelected">
              <b>Eliminar</b>
            </button>
          </v-col>
          <v-col class="col-12 col-sm-3 text-center text-sm-center">
            <button class="reprint-action-btn" @click="printAll">
              <b>Imprimir Todo</b>
            </button>
          </v-col>
          <v-col class="col-12 col-sm-3 text-center text-sm-left">
            <button class="reprint-action-btn" @click="printSelected">
              <b>Imprimir</b>
            </button>
          </v-col>
        </v-row>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import { printerErrorsCollection } from "@/collections/printerErrors";
import printerMixin from "@/mixins/printer/printerMixin";

export default {
  name: "printer-dialog",
  props: {
    groupOrderId: String
  },
  mixins: [printerMixin],
  data: () => ({
    dialog: false,
    printerErrors: [],
    selectedQR: "todas",
    selectLabelQR: "Mesa",
    selectedErrors: [],
    selectedItems: []
  }),
  firestore() {
    return {
      printerErrors: printerErrorsCollection
        .where("status", "==", true)
        .where("groupId", "==", this.groupOrderId)
    };
  },
  computed: {
    filteredErrors() {
      let printerErrors = JSON.parse(JSON.stringify(this.printerErrors));

      if (this.selectedQR !== "todas") {
        printerErrors = printerErrors.filter(
          item => item.data.id === this.selectedQR
        );
      }

      return printerErrors;
    },
    listQr() {
      let filteredQr = [];
      this.printerErrors.forEach(printer => {
        let found = filteredQr.some(item => item === printer.data.id);
        if (!found) {
          filteredQr.push(printer.data.id);
        }
      });
      filteredQr = ["todas", ...filteredQr];

      return filteredQr;
    }
  },
  methods: {
    open() {
      this.dialog = true;
      this.selectedErrors = [];
      this.selectedItems = [];
    },
    close() {
      this.dialog = false;
    },
    onChangeTable(value) {
      this.selectedQR = value;
      this.selectedItems = [];
      this.selectedErrors = [];
    },
    resetFilters() {
      this.selectedQR = "todas";
    },
    addSelectedItem(item) {
      let foundItem = this.selectedItems.some(x => x.id === item.id);
      if (foundItem) {
        this.selectedItems = this.selectedItems.filter(x => x.id !== item.id);
      } else {
        this.selectedItems.push(item);
      }
    },
    deleteSelected() {
      this.selectedItems.forEach(item => {
        this.deletePrinterError(item.id);
      });
      this.clearSelection();
    },
    printAll() {
      this.printerErrors.forEach(item => {
        this.reprintErroredItem(item.id, item.printerUrl, item.data);
      });
      this.clearSelection();
    },
    printSelected() {
      this.selectedItems.forEach(item => {
        this.reprintErroredItem(item.id, item.printerUrl, item.data);
      });
      this.clearSelection();
    },
    clearSelection() {
      setTimeout(() => {
        this.selectedItems = [];
        this.selectedErrors = [];
      }, 100);
    }
  }
};
</script>

<style scoped lang="scss">
.admin-add-products {
  overflow: hidden;
  overflow-y: auto;
}
.admin-reset-filters {
  margin-left: 16px;
  white-space: nowrap;
}
.btn-container {
  margin-bottom: 20px;
}
.reprint-action-btn {
  border: 2px solid black;
  padding: 15px 20px;
  margin: auto 20px;
  white-space: nowrap;
}
.red-dot {
  background: red;
  border-radius: 50%;
  width: 15px;
  height: 15px;
  display: inline-block;
}
.green-dot {
  background: green;
  border-radius: 50%;
  width: 15px;
  height: 15px;
  display: inline-block;
}
.admin-categories .tabs-stage .header-table th {
  width: 200px;
}
.admin-categories .tabs-stage .header-table th.header-notes1 {
  width: 300px;
}
@media screen and (max-width: 1024px) {
  .admin-categories .tabs-stage .gfg .geeks-notes1 {
    width: 200px;
  }
  .admin-categories .tabs-stage .gfg .geeks-notes2 {
    width: 300px;
  }
  .admin-categories .tabs-stage .gfg .geeks-notes3 {
    width: 100px;
    padding-left: 20px;
  }
  .admin-categories .tabs-stage .header-table th.header-action,
  .admin-categories .tabs-stage .header-table th.header-notes2 {
    width: 100px;
  }
}
</style>
